import { h, Component } from 'preact';
import { sortObjectByOrder } from 'utils/utils';
import { Link } from 'components/core/link/link';
import s from 'components/templates/navigation/navigation.sss';

export default class Navigation extends Component {
	render(props) {
		const items = sortObjectByOrder(props.data.items);

		return (
			<div class={s.wrapper}>
				<ul class={s.container}>
					{items.map(item => {
						const {
							name = '',
							pageId = '',
							href = ''
						} = item;

						return <li class={s.item}>
							<Link class={s.link} href={href} pageId={pageId}>
								{name}
							</Link>
						</li>

					})}
				</ul>
			</div>
		)
	}
}
